import React from "react"
import { graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MDXProvider } from "@mdx-js/react"
import { css } from "@emotion/core"
import {
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  HR,
  BlockQuote,
  LI,
  OL,
  Strong,
  EM,
  Pre,
  Code,
  P,
  A,
} from "../components/markdown-elements"

import Layout from "../components/layout"
import TableOfContents from "../components/table-of-contents"
import NextPreviousCard from "../components/next-previous-card"
import SEO from "../components/seo"
import PrettyGitalk from "../components/pretty-gitalk"
import MarkdownImage from "../components/markdown-image"

require(`katex/dist/katex.min.css`)

const leftRightGrid = css`
  display: grid;
  grid-template-areas: "left left left right";
  grid-column-gap: 100px;
  @media (max-width: 768px) {
    grid-template-areas: "left" "right";
  }
`

const components = {
  h1: props => <H1 {...props} />,
  h2: props => <H2 {...props} />,
  h3: props => <H3 {...props} />,
  h4: props => <H4 {...props} />,
  h5: props => <H5 {...props} />,
  h6: props => <H6 {...props} />,
  hr: props => <HR {...props} />,
  blockquote: props => <BlockQuote {...props} />,
  li: props => <LI {...props} />,
  ol: props => <OL {...props} />,
  strong: props => <Strong {...props} />,
  em: props => <EM {...props} />,
  pre: props => <Pre {...props} />,
  code: props => <Code {...props} />,
  p: props => <P {...props} />,
  a: props => <A {...props} />,
  MarkdownImage,
  // img: props => <MarkdownImage {...props} />,
  // p: props => <P {...props} />,
}

export default function BlogPost({ data, pageContext }) {
  const { previous, next } = pageContext

  const post = data.mdx
  return (
    <Layout>
      <MDXProvider components={components}>
        <SEO
          title={post.frontmatter.title}
          desc={post.frontmatter.description}
          pathname={post.fields.slug}
          article={true}
          post={post}
          banner={post.frontmatter.thumbnail.childImageSharp.fluid.src}
        />
        <div css={leftRightGrid}>
          <aside
            css={css`
              grid-area: right;
            `}
          >
            <TableOfContents tableOfContents={post.tableOfContents} />
          </aside>
          <article
            css={css`
              grid-area: left;
              font-size: 1.15rem;
            `}
          >
            <h1>{post.frontmatter.title}</h1>
            <MDXRenderer>{post.body}</MDXRenderer>
          </article>
        </div>
      </MDXProvider>
      <nav>
        <ul
          css={css`
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            list-style: none;
            padding: 0;
            margin: 0;
          `}
        >
          <li
            css={css`
              max-width: 300px;
            `}
          >
            {previous && (
              <NextPreviousCard node={previous} previous />
              // <Link to={previous.fields.slug} rel="prev">
              //   ← {previous.frontmatter.title}
              // </Link>
            )}
          </li>
          <li
            css={css`
              max-width: 300px;
            `}
          >
            {next && (
              <NextPreviousCard node={next} />
              // <Link to={next.fields.slug} rel="next">
              //   {next.frontmatter.title} →
              // </Link>
            )}
          </li>
        </ul>
      </nav>
      <PrettyGitalk post={post} />
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        date(formatString: "YYYY MMMM Do")
        description
        thumbnail {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      id
      body
      excerpt
      tableOfContents(maxDepth: 4)
      timeToRead
      fields {
        slug
      }
    }
  }
`
